// extracted by mini-css-extract-plugin
export var image = "HeroImage-module--image--HD6TI";